import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "alignItems", "gap", "paddingInline"],
  _excluded2 = ["isContactEnrichment", "recordsEligible", "recordsEnrichable", "recordsSelected"];
import { Body, LayoutBox, LayoutHorizontal, LayoutSpaceVertical, Link, LayoutVertical } from 'breeze-intelligence-kit';
import { MatchRate } from './MatchRate';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { MatchRateCards } from './MatchRateCards';
import { LiveEnrichmentDisclaimer } from '../LiveEnrichmentDisclaimer';
import { ObjectTypeLabel } from '../EnrichableObjectTypesProvider/EnrichmentLabels';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const KB_LINK = 'https://knowledge.hubspot.com/records/data-test-your-records-for-enrichment';
export const SectionMatchRateContainer = _ref => {
  let {
      children,
      alignItems = 'center',
      gap = 'space-lg',
      paddingInline = 'space-xl'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(LayoutVertical, Object.assign({}, rest, {
    alignItems: alignItems,
    gap: gap,
    paddingInline: paddingInline,
    children: children
  }));
};
const Title = ({
  isContactEnrichment
}) => {
  if (isContactEnrichment) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "dataTest.matchRate.contacts.title",
      options: {
        objectType: /*#__PURE__*/_jsx(ObjectTypeLabel, {
          isCapitalized: false,
          isPlural: true,
          type: "contact"
        })
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "dataTest.matchRate.companies.title",
    options: {
      objectType: /*#__PURE__*/_jsx(ObjectTypeLabel, {
        isCapitalized: false,
        isPlural: true,
        type: "company"
      })
    }
  });
};
export const SectionMatchRate = _ref2 => {
  let {
      isContactEnrichment,
      recordsEligible = 0,
      recordsEnrichable = 0,
      recordsSelected = 0
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(SectionMatchRateContainer, Object.assign({}, rest, {
    children: /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(LayoutHorizontal, {
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(MatchRate, {
          recordsEligible: recordsEligible,
          recordsEnrichable: recordsEnrichable
        })
      }), /*#__PURE__*/_jsx(Body, {
        children: /*#__PURE__*/_jsx(Title, {
          isContactEnrichment: isContactEnrichment
        })
      }), /*#__PURE__*/_jsxs(LiveEnrichmentDisclaimer, {
        isContactEnrichment: isContactEnrichment,
        marginInline: "auto",
        maxInlineSize: "63ch",
        children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "liveEnrichment.dataTest",
          options: {
            objectType: /*#__PURE__*/_jsx(ObjectTypeLabel, {
              isCapitalized: false,
              isPlural: true,
              type: "contact"
            })
          }
        }), ' ']
      }), /*#__PURE__*/_jsx(LayoutBox, {
        children: /*#__PURE__*/_jsx(Link, {
          href: KB_LINK,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "dataTest.matchRate.learnMoreLink"
          })
        })
      }), /*#__PURE__*/_jsx(MatchRateCards, {
        isContactEnrichment: isContactEnrichment,
        recordsEligible: recordsEligible,
        recordsEnrichable: recordsEnrichable,
        recordsSelected: recordsSelected
      })]
    })
  }));
};